import { Stack } from "@mui/material";
import { useContext } from "react";
import { useGetNavConfig } from "src/layouts/useGetNavConfig";

import Context, { ContextType } from "../context";
import { NavSectionVertical } from "./nav-section";

// -------------------------------------------------------

export default function NavbarContent() {
	const { isCollapse }: ContextType = useContext<ContextType>(Context);
	const { navConfig } = useGetNavConfig();

	return (
		<Stack
			sx={{
				height: 1,
				display: "flex",
				flexDirection: "column"
			}}
		>
			<Stack
				spacing={3}
				sx={{
					pb: 2,
					px: 2.5,
					flexShrink: 0,
					...(isCollapse && { alignItems: "center" })
				}}
			/>

			<NavSectionVertical isCollapse={isCollapse} navConfig={navConfig} />
		</Stack>
	);
}
